import React, { useEffect, lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import { Link, Redirect } from 'react-router-dom';
import Auth from '../../../utils/Auth';
import { changeLoginId } from '../../../redux/userAuthentication/userAuth.actions';
import Loader from '../../../utils/Loader';
import '../userAuthenticationStyles.css';
import { getParameterByName } from '../../../utils/commonFunctions';
import { setErrorPanel } from '../../../redux/utilities/utils.actions';
import {
	setResetPath,
	setUserType,
} from '../../../redux/userAuthentication/userAuth.actions';
import FadeIn from '../../utils/animations/fadein';

const ForgotPin = lazy(() => import('../sharedComponents/resendPin'));
const FootNote = lazy(() => import('../sharedComponents/footNote'));
const LoginForm = lazy(() => import('../sharedComponents/loginForm'));
const SocialLogin = lazy(() => import('../sharedComponents/socialLogin'));
const SignInButton = lazy(() => import('../sharedComponents/signInButton'));

const renderLoader = () => {
	return <p></p>;
};

const Login = ({
	error: { panelClass, panelMsg },
	returnPath,
	returnSearch,
	changeLoginId,
	setErrorPanel,
	setResetPath,
	setUserType,
	userType,
}) => {
	Loader.hide();
	useEffect(() => {
		setResetPath(getParameterByName('return_path') || '/mydashboard');
	}, [setResetPath]);

	useEffect(() => {
		if (getParameterByName('referrer') === 'magic_crate') {
			changeLoginId(getParameterByName('loginId'));
			let errorPanel = {
				panelClass: 'alert alert-success',
				panelMsg: 'PIN sent to phone/email. Enter PIN to get started.',
			};
			setErrorPanel(errorPanel);
		}
		return () => {
			localStorage.removeItem('sso');
		};
	}, [changeLoginId, setErrorPanel]);

	return (
		<Suspense fallback={renderLoader()}>
			<div id="wrapper">
				{Auth.isAuthenticated !== null &&
				(!localStorage.getItem('sso') ||
					(!!localStorage.getItem('sso') &&
						parseInt(localStorage.getItem('sso'), 10) !== 0)) ? (
					<Redirect to={{ pathname: returnPath, state: { from: '/login' } }} />
				) : (
					''
				)}
				<FadeIn className="col-lg-12 col-md-12 col-sm-12 login-pg-container">
					<div className="col-lg-12 col-md-12 col-sm-12 login-wrapper-container">
						<form action="" className="form-horizontal step-login-form" method="">
							<div className="col-lg-offset-4 col-md-offset-4 col-lg-4 col-md-4 col-sm-12 login-box">
								<div className="message_box">
									<div className={panelClass}>{panelMsg}</div>
								</div>
								<LoginForm headerText="Log in with" />
								<div className="pinResetBlock">
									{/*<Link to="/signup" className="pull-left">
										New user?
									</Link>*/}
									<ForgotPin resendPinText={'Forgot PIN?'} />
								</div>
								<br />
								<SignInButton signInText="LOG IN" />
								{/*<SocialLogin />*/}
								<hr />
								<FootNote userActivity="Log In" />
							</div>
						</form>
					</div>
				</FadeIn>
			</div>
		</Suspense>
	);
};

const mapStateToProps = (state) => {
	const { loginId, userType } = state.rootReducer.loginDetails;
	const { returnPath, returnSearch } = state.rootReducer.ssoDetails;
	return {
		loginId,
		error: state.rootReducer.utils.errorPanel,
		returnPath,
		returnSearch,
		userType,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		changeLoginId: (value) => dispatch(changeLoginId(value)),
		setErrorPanel: (msg) => dispatch(setErrorPanel(msg)),
		setResetPath: (path) => dispatch(setResetPath(path)),
		setUserType: (type) => dispatch(setUserType(type)),
	};
};

export default withRouter(
	compose(connect(mapStateToProps, mapDispatchToProps))(Login),
);
